import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import { IPagination } from 'app/types/common';
import { PaymentEventsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createPaymentEvent = (data): any => action(types.CREATE_PAYMENT_EVENT_REQUESTED, data);

export const updatePaymentEvent = (
  data,
  fixtureMatchDashboardId = undefined,
  paymentEventId = undefined,
): any => action(types.UPDATE_PAYMENT_EVENT_REQUESTED, {
  data,
  fixtureMatchDashboardId,
  paymentEventId,
});

export const deletePaymentEvent = (paymentEventId): any => action(types.UPDATE_PAYMENT_EVENT_REQUESTED, paymentEventId);

export const getPaymentEvent = (
  paymentEventId,
  eventDashboardId = undefined,
): any => action(types.GET_PAYMENT_EVENT_REQUESTED, { id: paymentEventId, eventDashboardId });

export const getAllPaymentEvents = (
  pagination: IPagination = undefined,
  compile = true,
  eventDashboardId = undefined,
): any => action(types.GET_ALL_PAYMENT_EVENTS_REQUESTED, {
  pagination,
  compile,
  eventDashboardId,
});

export const selectPaymentEvent = (paymentEventId): any => action(types.SELECT_PAYMENT_EVENT_REQUESTED, {
  currentPaymentEventId: paymentEventId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createPaymentEventPending: (payload): any => action(types.CREATE_PAYMENT_EVENT_PENDING, payload),
  createPaymentEventSuccess: (response): any => action(types.CREATE_PAYMENT_EVENT_SUCCESS, {
    paymentEventsById: response.entities.fixtureMatches,
    currentPaymentEventId: response.result,
  }),
  updatePaymentEventPending: (payload): any => action(types.UPDATE_PAYMENT_EVENT_PENDING, payload),
  updatePaymentEventSuccess: (response): any => action(types.UPDATE_PAYMENT_EVENT_SUCCESS, {
    paymentEventsById: response.entities.fixtureMatches,
    currentPaymentEventId: response.result,
  }),
  updatePaymentEventFailed: (error): any => action(types.UPDATE_PAYMENT_EVENT_FAIL, { backendErrors: error }),
  deletePaymentEventPending: (): any => action(types.UPDATE_PAYMENT_EVENT_PENDING, {}),
  deletePaymentEventSuccess: (response, userId): any => {
    localStorage.set(userId, { currentPaymentEventId: null });

    return action(types.DELETE_PAYMENT_EVENT_SUCCESS, {
      currentPaymentEventId: response,
    });
  },
  getPaymentEventPending: (): any => action(types.GET_PAYMENT_EVENT_PENDING, {}),
  getPaymentEventSuccess: (response): any => action(types.GET_PAYMENT_EVENT_SUCCESS, {
    paymentEventsById: response.entities.fixtureMatches,
    currentPaymentEventId: response.result,
  }),
  getPaymentEventFailed: (error): any => action(types.GET_PAYMENT_EVENT_FAIL, { backendErrors: error }),
  deletePaymentEventFailed: (error): any => action(types.UPDATE_PAYMENT_EVENT_FAIL, { backendErrors: error }),
  getAllPaymentEventsPending: (pagination): any => action(types.GET_ALL_PAYMENT_EVENTS_PENDING, { pagination }),
  getAllPaymentEventsSuccess: (response, meta): any => action(types.GET_ALL_PAYMENT_EVENTS_SUCCESS, {
    paymentEventsById: response.entities.fixtureMatches,
    paymentEventIds: response.result,
    meta,
  }),
  getAllPaymentEventsFailed: (error): any => action(types.GET_ALL_PAYMENT_EVENTS_FAIL, { backendErrors: error }),
  createPaymentEventFailed: (error): any => action(types.CREATE_PAYMENT_EVENT_FAIL, { backendErrors: error }),
};

export default null;
